/*
 * @Author: 李明明
 * @Date: 2022-07-28 14:08:34
 * @LastEditTime: 2023-04-06 16:10:55
 * @LastEditors: 李明明
 * @Description: 
 * @FilePath: /ykt-micro-main/src/utils/cookie.js
 * 代码版权方：'政府采购信息网'
 */
import Store from "../store";

// 设置cookie
function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires="+d.toUTCString() + ";domain=.caigou2003.com";
  document.cookie = cname + "=" + cvalue + "; " + expires;
}

/**
 * 获取cookie
 * @param name
 * @returns {string}
 */
export function getCookie(name) {
  const arr = document.cookie.split("; ");
  for (let i = 0; i < arr.length; i++) {
    const arr2 = arr[i].split("=");
    if (arr2[0] == name) {
      let value = arr2.slice(1).join("=");

      // 先兼容旧数据里的 %uXXXX 编码（例如 %u674E%u660E%u660E）
      if (/%u[0-9a-fA-F]{4}/.test(value)) {
        value = value.replace(/%u([0-9a-fA-F]{4})/g, (_, hex) =>
          String.fromCharCode(parseInt(hex, 16))
        );
      }

      // 再尝试做 URL 解码（兼容 %7B%22...%22%7D 这种形式）
      try {
        // 先将 + 号替换为空格，避免 decodeURIComponent 失败
        value = value.replace(/\+/g, ' ');
        // 尝试多次解码，确保所有 URL 编码的字符都被解码
        let decodedValue = value;
        let previousValue;
        do {
          previousValue = decodedValue;
          decodedValue = decodeURIComponent(decodedValue);
        } while (decodedValue !== previousValue);
        value = decodedValue;
      } catch (e) {
        // 不是合法的 URI 编码就保持原样
      }

      return value;
    }
  }
  return ""
}

/**
 * 安全地解析 JSON 格式的 cookie 值
 * @param {string} name - cookie 名称
 * @returns {object} 解析后的对象，解析失败返回空对象
 */
export function getCookieAsJSON(name) {
  try {
    let value = getCookie(name);
    if (!value) return {};
    
    // 先处理 + 号，替换为空格
    value = value.replace(/\+/g, ' ');
    
    // 尝试直接解析
    try {
      return JSON.parse(value) || {};
    } catch (e1) {
      console.warn(`直接解析 cookie ${name} 失败:`, e1);
    }
    
    // 尝试使用 decodeURIComponent 解码后解析
    try {
      const decodedValue = decodeURIComponent(value);
      return JSON.parse(decodedValue) || {};
    } catch (e2) {
      console.warn(`使用 decodeURIComponent 解析 cookie ${name} 失败:`, e2);
    }
    
    // 尝试使用 unescape 解码后解析（作为最终兜底方案）
    try {
      const unescapedValue = unescape(value);
      return JSON.parse(unescapedValue) || {};
    } catch (e3) {
      console.warn(`使用 unescape 解析 cookie ${name} 失败:`, e3);
    }
    
    // 所有尝试都失败，返回空对象
    return {};
  } catch (e) {
    // 捕获所有可能的错误，返回空对象
    console.warn(`解析 cookie ${name} 失败:`, e);
    return {};
  }
}

// 删除cookie
export function clearCookie(name) {
  Store.state.userInfo = {}
  setCookie(name, "", -1);
}
